/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.coupons.create.detail.controllers', [
  'acme.common.service.api',
  'acme.common.service.permissions',
  'acme.common.service.helpers'
])

.controller('CouponsCreateDetailController', ['$scope', '$state', '$q', 'ApiService', 'PermissionsService', 'HelpersService', function($scope, $state, $q, ApiService, PermissionsService, HelpersService) {

    $scope.couponsCreateDetail = {

      model: {},

      errorMessage: '',

      categories: [],

      coupons: [],

      accounts: [],
      
      init: function() {
        var self = $scope.couponsCreateDetail,
            title = {
              title: 'Edit Coupon Details',
              buttonLeft: {
                label: 'Cancel',
                action: function() {
                  $state.go('application.coupons.list');
                }
              },
              buttonRight: {
                label: 'Save & Close',
                permissions: ['COUPONS_UPDATE'],
                action: function() {
                  $scope.couponsCreateDetail.complete(true);
                }
              }
            };
        
        $scope.$emit('Application::contentTitleChange', title);

        $scope.$on("CouponsCreateController::save", this.onSave);
        $q.all([
          self.getCouponCategories(),
          self.getCoupons(),
          self.getCouponAccounts(),
          self.getCoupon($state.params.couponId)
        ]);
        
      },
      
      checkPermissions: function(permission){
        return PermissionsService.check(permission);
      },

      getCoupon: function(id) {
        ApiService.coupons.detail(id).then(this.success.getCoupon, this.error.getCoupon);
      },

      getCouponCategories: function() {
        ApiService.coupons.categories.list(HelpersService.getPaginator()).then(this.success.getCategories, this.error.getCategories);
      },

      getCoupons: function() {
        ApiService.coupons.list(HelpersService.getPaginator()).then(this.success.getCoupons, this.error.getCoupons);
      },

      getCouponAccounts: function() {
        var gridState = HelpersService.getPaginator({sortField : 'name'});
        ApiService.partners.list(gridState).then(this.success.getCouponAccounts, this.error.getCouponAccounts);
      },

      trim: function(s) {
        return s.replace(/\s+/g, '').toLowerCase();
      },

      isUnique: function(property) {
        var i, ii,
          trimmed,
          trimmedCurrent = this.trim(this.model[property]),
          r = true;
        this.errorMessage = '';
        if (trimmedCurrent.length <= 0) {
          r = false;
          this.errorMessage = 'Please enter a valid '+property;
        } else {
          for (i=0,ii=this.coupons.length;i<ii;i++) {
            trimmed = this.trim(this.coupons[i][property]);
            if ( (trimmedCurrent === trimmed) && (this.model.id !== this.coupons[i].id) ) {
              r = false;
              this.errorMessage = 'A coupon with this '+property+' already exists.';
              break;
            }
          }
        }

        return r;

      },

      isValid: function() {
        var r = true;
        if (this.isSubmitted) {
          r = ( (this.isUnique('name')) &&
                (this.isUnique('code')) );
        }

        return r;
      },

      onSave: function(e, data) {
        var self = $scope.couponsCreateDetail;
        self.next = data.state;
        self.complete();
      },

      complete: function(close) {
        var errorHandler = (close) ? this.error.saveAndClose : this.error.complete,
          successHandler = (close) ? this.success.saveAndClose : this.success.complete;
        $scope.$emit('CouponsCreateController::reset');
        this.isSubmitted = true;

        console.log('CouponsCreateDetailController::complete', this.model.name);

        if (this.isValid()) {
          if (this.model.resellerId) {
            this.model.companyName = '';
          }
          ApiService.coupons.update(this.model).then(successHandler, errorHandler);
        }else{
          $scope.$emit('CouponsCreateController::error', {
            message:  this.errorMessage
          });
        }
      },

      success: {
        init: function(response) {},

        getCoupon: function(response) {
          $scope.couponsCreateDetail.model = response.data.payload;
          $scope.couponsCreateDetail.model.resellerId = parseInt(response.data.payload.resellerId, 10);
        },

        getCategories: function(response) {
          $scope.couponsCreateDetail.categories = response.data.payload.list;
        },

        getCoupons: function(response) {
          $scope.couponsCreateDetail.coupons = response.data.payload.list;
        },

        getCouponAccounts: function(response) {
          $scope.couponsCreateDetail.accounts = response.data.payload.list.map( function(account) {
            return account.company;
          });
        },

        complete: function(response) {
          var self = $scope.couponsCreateDetail;
          self.isSubmitted = true;
          $state.go(self.next, { couponId: response.data.payload.id });
        },

        saveAndClose: function(response) {
          $scope.couponsCreateDetail.isSubmitted = true;
          $scope.$emit('CouponsCreateController::success', {
            message: 'Successfully Saved!'
          });

          $scope.$emit('CouponsCreateController::transition', {
            state: 'application.coupons.list'
          });
        }
      },

      error: {
        init: function(response) {},

        getCoupon: function(response) {},

        getCategories: function(response) {},

        getCoupons: function(response) {},

        getCouponAccounts: function(response) {},

        complete: function(response) {
          $scope.$emit('CouponsCreateController::error', {
            message:  response.data.error
          });
        },

        saveAndClose: function(response) {
          $scope.$emit('CouponsCreateController::error', {
            message:  response.data.error
          });
        }
      }

    };

    $scope.couponsCreateDetail.init();

}]);